import { PipeTransform, Pipe } from '@angular/core';
import moment from 'moment';
import { DealType } from '../types/deal.types';

@Pipe({
  name: 'orderPeriodCountdown'
})
export class OrderPeriodCountdownPipe implements PipeTransform {
  public transform(ms: number, dealType: DealType): string | null {
    if (ms === null || ms === undefined) {
      return null;
    }
    switch (dealType) {
      case DealType.competitive:
      case DealType.negotiated:
      case DealType.privatePlacement:
        return this.formatCountDown(ms);
      default:
        throw new Error(`${dealType} deal type is wrong`);
    }
  }

  private formatCountDown(ms: number): string {
    const hours: number = Math.floor(moment.duration(ms).asHours());
    const countdown = `${hours > 9 ? hours : `0${hours}`}${moment
      .utc(ms)
      .format(':mm:ss')}`;
    return countdown;
  }
}
